var render, staticRenderFns
import script from "./FieldMixin.vue?vue&type=script&lang=ts&"
export * from "./FieldMixin.vue?vue&type=script&lang=ts&"
import style0 from "./FieldMixin.vue?vue&type=style&index=0&id=6bfbafd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports